import { Tab } from "@headlessui/react";
import cx from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";

import SettingsTitleWrapper from "@/components/editor/shared/settings-title-wrapper";

import { LibrarySetting } from "./library-setting";
import { VideoURLSetting } from "./url-setting";

export function VideoSettings() {
  const [tabIndex, setTabIndex] = React.useState(0);
  const { t } = useTranslation();

  return (
    <SettingsTitleWrapper>
      <Tab.Group
        as="div"
        selectedIndex={tabIndex}
        onChange={setTabIndex}
        className="relative flex w-full flex-col"
        data-testid="video-settings-tabs"
      >
        <Tab.List className="mb-4 flex h-12 w-full items-center text-sm">
          <Tab
            className={cx(
              "basis-1/4 border-b-2 px-6 py-3 font-medium text-gray-600 outline-none hover:bg-gray-200 hover:text-gray-800",
              {
                "border-b-blue-500 text-gray-800": tabIndex === 0,
                "border-b-gray-200": tabIndex !== 0,
              }
            )}
          >
            {t("preference-panel.library")}
          </Tab>
          <Tab
            className={cx(
              "basis-1/4 border-b-2 px-6 py-3 font-medium text-gray-600 outline-none hover:bg-gray-200 hover:text-gray-800",
              {
                "border-b-blue-500 text-gray-800": tabIndex === 1,
                "border-b-gray-200": tabIndex !== 1,
              }
            )}
          >
            {t("preference-panel.url")}
          </Tab>
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel>
            <LibrarySetting />
          </Tab.Panel>
          <Tab.Panel>
            <VideoURLSetting />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </SettingsTitleWrapper>
  );
}
